import { EventBaseData } from "./event.model";

export class SystemDataLoadEvent extends EventBaseData {
  constructor(
    public isLoaded: boolean) {
    super();
  }
}
